import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, stopPropagation } from '@nu-art/thunderstorm-frontend/index';
import './Page_Sandbox.scss';
import { Outlet } from 'react-router';
import { Page_SandboxNLP } from './Sandbox_NLP/index.js';
import { Page_SandboxOrder } from './Sandbox_Order/index.js';
import { Page_SandboxFrame } from './Page_SandboxFrame/Page_SandboxFrame.js';
import { ComponentValidateSession } from '../components/ComponentValidateSession.js';
import { Page_SandboxFHIRQuery } from './Sandbox_FHIRQuery/Page_SandboxFHIRQuery.js';
import { Page_SandboxFHIR } from './Sandbox_FHIRSandbox/index.js';
export class Page_Sandbox extends ComponentSync {
    static Route = {
        key: 'sandbox',
        path: 'sandbox',
        Component: ComponentValidateSession,
        children: [
            Page_SandboxNLP.Route,
            Page_SandboxFrame.Route,
            Page_SandboxOrder.Route,
            Page_SandboxFHIRQuery.Route,
            Page_SandboxFHIR.Route,
        ]
    };
    deriveStateFromProps(nextProps, state) {
        return state;
    }
    render() {
        return _jsx("div", { id: "page-sandbox", onContextMenu: stopPropagation, children: _jsx(Outlet, {}) });
    }
}
//# sourceMappingURL=Page_Sandbox.js.map